import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Push registration disabled - re-enable when /api/save-subscription backend exists
// See utils/push.ts for urlBase64ToUint8Array helper

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
